import { SVGProps } from "react"

const DictationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M13.3334 9.58332V4.99999C13.3334 3.15832 11.8417 1.66666 10 1.66666C8.15835 1.66666 6.66669 3.15832 6.66669 4.99999V9.58332C6.66669 11.425 8.15835 12.9167 10 12.9167C11.8417 12.9167 13.3334 11.425 13.3334 9.58332Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.62506 8.0416V9.45826C3.62506 12.9749 6.48339 15.8333 10.0001 15.8333C13.5167 15.8333 16.3751 12.9749 16.3751 9.45826V8.0416"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.84174 5.35844C9.59174 5.08344 10.4084 5.08344 11.1584 5.35844"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33331 7.12507C9.77498 7.0084 10.2333 7.0084 10.675 7.12507"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 15.8333V18.3333"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default DictationIcon